import React, { useEffect, useState } from 'react'

import Select from 'react-select'
import styled from 'styled-components'
import {
    SelectBtn,
    FormInputContainer,
    FormInputLabel,
} from '@appearance/styled'
import i18n from '@localization/i18n'

export default ({
    label,
    value,
    onChange,
    onInputChange,
    placeholder,
    options,
    inputHeight = 40,
    width,
    required,
}) => {
    const [text, settext] = useState([])
    const [newOption, setNewOption] = useState([{ label: text, value: text }])

    const customStyles = {
        control: (provided) => {
            const minHeight = inputHeight
            return { ...provided, minHeight }
        },
    }
    const newLocalOnChangeText = (text) => {
        onChange(text)
        setNewOption([{ label: text, value: text }])
    }

    return (
        <FormInputContainer width={width}>
            {/* <FormInputLabel>{label}</FormInputLabel> */}
            {label && (
                <FormInputLabel lang={i18n.locale}>
                    {label}
                    {required && <RequiredSign> * </RequiredSign>}
                </FormInputLabel>
            )}
            <SelectBtn
                style={{
                    textAlign: 'right',
                }}
                height={inputHeight}>
                <Select
                    isMulti
                    required={required}
                    placeholder={placeholder}
                    value={value}
                    onChange={newLocalOnChangeText}
                    // onChange={onChange}
                    // onChange={onChange && setNewOption}
                    options={
                        options?.length === 0
                            ? newOption
                            : options.filter(
                                  (option) =>
                                      option.label.trim() !==
                                      '(הוסף חדש)'.trim()
                              )
                    }
                    // options={newOption}
                    height={inputHeight}
                    styles={customStyles}
                    onInputChange={onInputChange}
                />
            </SelectBtn>
        </FormInputContainer>
    )
}
const RequiredSign = styled.span`
    color: red;
`
